import React from "react";
import { Routes, Route, useLocation } from "react-router-dom";
import Header from "./components/Header";
import Hero from "./components/Hero";
import About from "./components/About";
import Books from "./components/Books";
import Cart from "./components/Cart";
import Contact from "./components/Contact";
import Footer from "./components/Footer";
import ProductDetail from "./components/ProductDetail";
import Gallery from "./components/Gallery";
import Blog from "./components/Blog";
import BlogDetail from "./components/BlogDetail";
import TermsAndConditions from "./components/TermsAndConditions";
import ProtectedRoute from "./components/admin/ProtectedRoute";
import Login from "./components/admin/Login";
import Dashboard from "./components/admin/Dashboard";
import Success from "./components/Success";

function App() {
  const isAdmin = localStorage.getItem("adminAuthenticated") === "true";
  const location = useLocation();

  return (
    <div className="app">
      <div>
        {!isAdmin && location.pathname !== "/admin/login" && <Header />}
        <Routes>
          <Route
            path="/admin/dashboard"
            element={
              <ProtectedRoute>
                <Dashboard />
              </ProtectedRoute>
            }
          />
          <Route path="/admin/login" element={<Login />} />
        </Routes>
      </div>
      <Routes>
        <Route path="/" element={<Hero />} />
        <Route path="/about" element={<About />} />
        <Route path="/books" element={<Books />} />
        <Route path="/cart" element={<Cart />} />
        <Route path="/contact" element={<Contact />} />
        <Route path="/producto/:slug" element={<ProductDetail />} />
        <Route path="/galery" element={<Gallery />} />
        <Route path="/blog" element={<Blog />} />
        <Route path="/blog/:id" element={<BlogDetail />} />
        <Route path="/terminos" element={<TermsAndConditions />} />
        <Route path="success" element={<Success />} />
        
      </Routes>
      <Footer />
    </div>
  );
}

export default App;
